import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { LineContainerComponent } from "shared-ui-components/lines/lineContainerComponent";
import "./propertyTab.scss";
import { Vector2LineComponent } from "shared-ui-components/lines/vector2LineComponent";
import { Vector3LineComponent } from "shared-ui-components/lines/vector3LineComponent";
import { FloatLineComponent } from "shared-ui-components/lines/floatLineComponent";
import { SliderLineComponent } from "shared-ui-components/lines/sliderLineComponent";
import { NodeParticleBlockConnectionPointTypes } from "core/Particles/Node/Enums/nodeParticleBlockConnectionPointTypes";
import { Color4PropertyTabComponent } from "./properties/color4PropertyTabComponent";
export class InputsPropertyTabComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    processInputBlockUpdate() {
        this.props.globalState.stateManager.onRebuildRequiredObservable.notifyObservers();
    }
    renderInputBlock(block) {
        switch (block.type) {
            case NodeParticleBlockConnectionPointTypes.Int:
            case NodeParticleBlockConnectionPointTypes.Float: {
                const cantDisplaySlider = isNaN(block.min) || isNaN(block.max) || block.min === block.max;
                const isInteger = block.type === NodeParticleBlockConnectionPointTypes.Int;
                return (_jsxs("div", { children: [cantDisplaySlider && (_jsx(FloatLineComponent, { lockObject: this.props.lockObject, label: block.name, target: block, isInteger: isInteger, propertyName: "value", onChange: () => this.processInputBlockUpdate() }, block.uniqueId)), !cantDisplaySlider && (_jsx(SliderLineComponent, { lockObject: this.props.lockObject, label: block.name, target: block, propertyName: "value", step: isInteger ? 1 : Math.abs(block.max - block.min) / 100.0, decimalCount: isInteger ? 0 : 2, minimum: block.min, maximum: block.max, onChange: () => this.processInputBlockUpdate() }, block.uniqueId))] }, block.uniqueId));
            }
            case NodeParticleBlockConnectionPointTypes.Vector2:
                return (_jsx(Vector2LineComponent, { lockObject: this.props.lockObject, label: block.name, target: block, propertyName: "value", onChange: () => this.processInputBlockUpdate() }, block.uniqueId));
            case NodeParticleBlockConnectionPointTypes.Vector3:
                return (_jsx(Vector3LineComponent, { lockObject: this.props.lockObject, label: block.name, target: block, propertyName: "value", onChange: () => this.processInputBlockUpdate() }, block.uniqueId));
            case NodeParticleBlockConnectionPointTypes.Color4:
                return _jsx(Color4PropertyTabComponent, { lockObject: this.props.lockObject, globalState: this.props.globalState, inputBlock: block }, block.uniqueId);
        }
        return null;
    }
    render() {
        return (_jsx(LineContainerComponent, { title: "INPUTS", children: this.props.inputs.map((ib) => {
                if (ib.isSystemSource || ib.isContextual || !ib.name || !ib.displayInInspector) {
                    return null;
                }
                return this.renderInputBlock(ib);
            }) }));
    }
}
//# sourceMappingURL=inputsPropertyTabComponent.js.map